"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
require("../types/theme-config");
var globalStyles = {
    html: { scrollBehavior: 'smooth' },
    'html, body': {
        width: '100%',
        margin: 0,
    },
    'body': {
        overflowX: 'hidden',
    },
    '@media screen and (prefers-reduced-motion: reduce)': {
        html: {
            scrollBehavior: 'auto',
        },
    },
};
function MUIThemeProvider(_a) {
    var theme = _a.theme, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(material_1.ThemeProvider, { theme: theme, children: (0, jsx_runtime_1.jsxs)(material_1.ScopedCssBaseline, { id: "mui-scoped-baseline", children: [(0, jsx_runtime_1.jsx)(material_1.GlobalStyles, { styles: globalStyles }), children] }) }));
}
exports.default = MUIThemeProvider;
